'use client';

import * as React from 'react';
import { useStableId } from './useStableId.ts';
import type { UseFormFieldStateReturn } from '@federa/types/ui-form-field';

export function useFormFieldState(providedId?: string): UseFormFieldStateReturn {
	const [isFocused, setIsFocused] = React.useState(false);
	const fieldId = useStableId(providedId);
	const helperId = React.useMemo(() => `${fieldId}-helper`, [fieldId]);

	return {
		isFocused,
		setIsFocused,
		fieldId,
		helperId,
	};
}
